var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { st, classes } from './CheckboxGroup.st.css';
import { Fieldset } from '../internal/Fieldset';
import { CheckboxGroupLayout, } from './types';
var uniqueId = require('lodash/uniqueId');
var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup(props) {
        var _this = _super.call(this, props) || this;
        _this._errorMessageId = uniqueId('error-message');
        return _this;
    }
    CheckboxGroup.prototype.render = function () {
        var _a = this.props, label = _a.label, layout = _a.layout, error = _a.error, disabled = _a.disabled, errorText = _a.errorText, className = _a.className, newErrorMessage = _a.newErrorMessage;
        var stStates = { disabled: disabled, layout: layout, error: error, newErrorMessage: newErrorMessage };
        var isErrorMessageProvided = errorText && errorText.length > 0;
        return (React.createElement(Fieldset, { errorMessage: newErrorMessage && error && errorText, errorMessageId: this._errorMessageId, "data-hook": this.props['data-hook'], className: st(classes.root, stStates, className), label: label },
            React.createElement("div", { className: classes.wrapper }, React.Children.map(this.props.children, function (child, idx) {
                if (!React.isValidElement(child)) {
                    return null;
                }
                return (React.createElement(React.Fragment, null, React.cloneElement(child, {
                    key: idx,
                    error: error,
                    disabled: disabled,
                    className: st(classes.checkboxItem, child.props.className),
                })));
            })),
            error && isErrorMessageProvided && !disabled && !newErrorMessage && (React.createElement("span", { className: classes.error }, errorText))));
    };
    CheckboxGroup.displayName = 'CheckboxGroup';
    CheckboxGroup.defaultProps = {
        layout: CheckboxGroupLayout.Vertical,
    };
    return CheckboxGroup;
}(React.Component));
export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.js.map